/*
  Paginile de târguri pe oraș (template page.targuri-oras).

  Lista de târguri se randează acum la server, în Liquid
  (sections/mcb-targuri-oras-lista.liquid, din snippets/targuri-oras-date.liquid),
  deci aici nu se mai încarcă, nu se mai filtrează și nu se mai mută nimic.
  Ordinea secțiunilor e doar cea din templates/page.targuri-oras.json.

  Rămân butonul „Salvează în calendar”, același ca pe pagina generală
  (funcțiile calendarul ... descarca sunt copiate de acolo, neschimbate), și
  filtrul pe luni (luni): butoanele [data-oras-luni] ascund cardurile din
  alte luni în ambele liste ale paginii, apoi sezoanele, grupurile și
  secțiunile rămase goale. Fără JavaScript butoanele nu apar și se văd
  toate târgurile.
*/
(function () {
  if (window.mcbTarguriOras) return;
  window.mcbTarguriOras = true;

  function porneste() {
    calendarul();
    luni();
  }

  /* Ascunde ce nu se potrivește cu luna aleasă („” = toate). Pe fiecare
     grilă, data-n (pus din Liquid cu numărul de carduri) devine numărul de
     carduri rămase, ca CSS-ul să aleagă 1, 2 sau 3 coloane după cardurile
     vizibile; la „Toate” revine la valoarea din Liquid. */
  function filtreaza(luna) {
    var liste = document.querySelectorAll('.oras-lista');
    liste.forEach(function (lista) {
      lista.querySelectorAll('.oras-sezon').forEach(function (sezon) {
        var trecute = sezon.classList.contains('oras-sezon--trecute');
        var vizibileSezon = 0;
        sezon.querySelectorAll('ul.wfair-grid').forEach(function (ul) {
          var n = 0;
          ul.querySelectorAll('[data-targuri-card]').forEach(function (card) {
            var arata = !luna || (!trecute && card.getAttribute('data-luna') === luna);
            card.hidden = !arata;
            if (arata) n++;
          });
          ul.hidden = n === 0;
          if (!ul.hasAttribute('data-n-toate')) ul.setAttribute('data-n-toate', ul.getAttribute('data-n') || '');
          ul.setAttribute('data-n', luna ? n : ul.getAttribute('data-n-toate'));
          var titlu = ul.previousElementSibling;
          if (titlu && titlu.classList.contains('oras-sezon__estimate-titlu')) titlu.hidden = n === 0;
          vizibileSezon += n;
        });
        sezon.hidden = vizibileSezon === 0;
      });
      var ramase = lista.querySelectorAll('[data-targuri-card]:not([hidden])').length;
      if (lista.classList.contains('oras-lista--restul')) {
        var bloc = lista.closest('.mcb') || lista;
        bloc.hidden = ramase === 0;
      }
      lista.setAttribute('data-ramase', ramase);
    });
    /* Luna aleasă e doar în lista de sub ghid: un rând care trimite acolo. */
    var nota = document.querySelector('[data-oras-luni-nota]');
    var prima = document.querySelector('.oras-lista:not(.oras-lista--restul)');
    if (nota && prima) nota.hidden = !luna || prima.getAttribute('data-ramase') !== '0';
  }

  function luni() {
    var grup = document.querySelector('[data-oras-luni]');
    if (!grup) return;
    grup.hidden = false;
    grup.addEventListener('click', function (ev) {
      var buton = ev.target.closest ? ev.target.closest('button[data-luna]') : null;
      if (!buton) return;
      grup.querySelectorAll('button[data-luna]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === buton ? 'true' : 'false');
      });
      filtreaza(buton.getAttribute('data-luna'));
    });
  }

  function calendarul() {
    document.addEventListener('click', function (ev) {
      var buton = ev.target.closest ? ev.target.closest('[data-targuri-ics]') : null;
      if (!buton) return;
      descarca(buton);
    });
  }

  function cifre(data) {
    return String(data).replace(/-/g, '');
  }

  function ziuaUrmatoare(data) {
    var d = new Date(data + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + 1);
    return d.toISOString().slice(0, 10).replace(/-/g, '');
  }

  function curata(text) {
    return String(text || '')
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\r?\n/g, '\\n');
  }

  /* RFC 5545 cere linii de maximum 75 de octeti, iar diacriticele
     ocupa doi octeti fiecare, deci numaram octeti, nu caractere. */
  function octeti(car) {
    var cod = car.codePointAt(0);
    if (cod < 0x80) return 1;
    if (cod < 0x800) return 2;
    if (cod < 0x10000) return 3;
    return 4;
  }

  function indoaie(linie) {
    var bucati = [];
    var curenta = '';
    var lungime = 0;
    var limita = 74;

    for (var i = 0; i < linie.length; i++) {
      var car = linie[i];
      var cat = octeti(car);
      if (lungime + cat > limita) {
        bucati.push(curenta);
        curenta = ' ';
        lungime = 1;
      }
      curenta += car;
      lungime += cat;
    }
    if (curenta) bucati.push(curenta);
    return bucati.join('\r\n');
  }

  function descarca(buton) {
    var nume = buton.getAttribute('data-ics-nume');
    var start = buton.getAttribute('data-ics-start');
    var final = buton.getAttribute('data-ics-final') || start;
    var loc = buton.getAttribute('data-ics-loc') || '';
    var sigur = buton.getAttribute('data-ics-sigur');
    var link = buton.getAttribute('data-ics-link') || '';
    if (!start) return;

    var titlu = sigur === 'confirmat' ? nume : nume + ' (dată estimată)';
    var descriere =
      sigur === 'confirmat'
        ? 'Târg de nunți. Verifică programul pe pagina organizatorului înainte să pleci.'
        : 'Târg de nunți. Perioada e estimată după edițiile din anii trecuți, organizatorul nu a anunțat încă data oficială. Verifică înainte să îți faci drum.';
    if (link) descriere += '\n' + link;
    descriere += '\nCalendar de pe miresicacubuget.ro';

    var acum = new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    var randuri = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Miresica cu Buget//Targuri de nunti//RO',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      'UID:' + cifre(start) + '-' + Math.random().toString(36).slice(2, 10) + '@miresicacubuget.ro',
      'DTSTAMP:' + acum,
      'DTSTART;VALUE=DATE:' + cifre(start),
      'DTEND;VALUE=DATE:' + ziuaUrmatoare(final),
      indoaie('SUMMARY:' + curata(titlu)),
      indoaie('LOCATION:' + curata(loc)),
      indoaie('DESCRIPTION:' + curata(descriere))
    ];
    if (link) randuri.push(indoaie('URL:' + curata(link)));
    randuri.push(
      'BEGIN:VALARM',
      'TRIGGER:-P2D',
      'ACTION:DISPLAY',
      indoaie('DESCRIPTION:' + curata(titlu)),
      'END:VALARM',
      'END:VEVENT',
      'END:VCALENDAR'
    );

    var fisier = new Blob([randuri.join('\r\n')], {
      type: 'text/calendar;charset=utf-8'
    });
    var adresa = URL.createObjectURL(fisier);
    var legatura = document.createElement('a');
    legatura.href = adresa;
    legatura.download =
      String(nume)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') + '.ics';
    document.body.appendChild(legatura);
    legatura.click();
    document.body.removeChild(legatura);
    setTimeout(function () {
      URL.revokeObjectURL(adresa);
    }, 2000);

    var eticheta = buton.querySelector('.targ-card__calendar-text');
    if (eticheta && !buton.dataset.ocupat) {
      var vechi = eticheta.textContent;
      buton.dataset.ocupat = '1';
      eticheta.textContent = 'Descărcat';
      buton.classList.add('is-salvat');
      setTimeout(function () {
        eticheta.textContent = vechi;
        buton.classList.remove('is-salvat');
        delete buton.dataset.ocupat;
      }, 2200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
})();
